import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export class SnackBarData {
	type: 'failure' | 'success';

	message: string;
}

@Component({
	selector: 'ss-snackbar',
	templateUrl: './snackbar.component.html',
	styleUrls: ['./snackbar.component.scss'],
	imports: [MatIconModule]
})
export class SnackbarComponent implements OnInit {
	data = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

	fontSet: string;

	fontIcon: string;

	private successIcons = [
		{ set: 'fas', name: 'fa-thumbs-up' },
		{ set: 'fas', name: 'fa-rocket' },
		{ set: 'fas', name: 'fa-medal' },
	];

	private failureIcons = [
		{ set: 'fas', name: 'fa-circle-exclamation' },
		{ set: 'fas', name: 'fa-bolt' },
		{ set: 'fas', name: 'fa-car-burst' },
	];

	ngOnInit(): void {
		let icon;
		if (this.data.type === 'failure') {
			icon =
				this.failureIcons[
					Math.floor(Math.random() * this.failureIcons.length)
				];
		} else {
			icon =
				this.successIcons[
					Math.floor(Math.random() * this.successIcons.length)
				];
		}
		this.fontSet = icon.set;
		this.fontIcon = icon.name;
	}
}
